import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { Shell } from "../components/Shell";
import api from "../lib/api";
import { toast } from "sonner";

export default function Contact() {
    const { t, user, apiErr } = useApp();
    const [form, setForm] = useState({ name: user?.name || "", email: user?.email || "", message: "" });
    const [sending, setSending] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || form.message.length < 3) { toast.error(t("common.required")); return; }
        setSending(true);
        try {
            await api.post("/support", form);
            setDone(true);
            toast.success("Message sent. We'll get back to you.");
        } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
        setSending(false);
    };

    return (
        <Shell eyebrow={t("nav.contact")} title="Contact & support" intro="Questions about your reflection, a payment, or your account? Send us a message." max="max-w-2xl">
            {done ? (
                <div className="card-soft p-8 text-center" data-testid="support-success">
                    <p className="text-forest text-xl font-serif">Thank you.</p>
                    <p className="mt-2 text-charcoal/75 text-sm">Your message has reached us. We'll reply to {form.email}.</p>
                </div>
            ) : (
                <form onSubmit={submit} className="card-soft p-8 space-y-4">
                    <div>
                        <label className="text-sm font-medium">Name</label>
                        <input data-testid="contact-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                            className="mt-1 w-full rounded-xl border border-charcoal/15 px-4 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-forest/30" />
                    </div>
                    <div>
                        <label className="text-sm font-medium">Email</label>
                        <input data-testid="contact-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                            className="mt-1 w-full rounded-xl border border-charcoal/15 px-4 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-forest/30" />
                    </div>
                    <div>
                        <label className="text-sm font-medium">Message</label>
                        <textarea data-testid="contact-message" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                            className="mt-1 w-full rounded-xl border border-charcoal/15 px-4 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-forest/30" />
                    </div>
                    <button data-testid="contact-submit" disabled={sending} className="btn-primary px-6 py-3 font-medium disabled:opacity-60">{sending ? t("common.saving") : t("common.send")}</button>
                </form>
            )}
        </Shell>
    );
}
